import type { FC } from "react";

import { Button, Modal, Text } from "@alpacahq/ui/old";

type OrderFlowDisclosureModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onComplete: () => void;
};

export const OrderFlowDisclosureModal: FC<OrderFlowDisclosureModalProps> = ({
  isOpen,
  setIsOpen,
  onComplete,
}) => {
  return (
    <Modal
      size="xl"
      title="Please read the following disclosure"
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      controls={
        <div className="flex w-full items-center justify-between gap-4">
          <Button variant="secondary" onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
          <Button onClick={onComplete}>Understood</Button>
        </div>
      }
    >
      <div>
        <Text className="mb-2 font-semibold">
          Who is the Elite Smart Router for? If any one of these checklists
          applies, great news! This is for you.
        </Text>
        <ul className="ml-8 list-disc space-y-2 text-sm">
          <li>
            Want to send large ticket size (10,000 shares or over $200,000 in
            notional value per trading day)
          </li>
          <li>
            Want to participate in open/close auctions (MOO/LOO, MOC/LPC order
            types)
          </li>
          <li>
            Want to trade premium order types such as IOC, as well as VWAP,
            TWAP, Pegged, and Midpoint, which will be available soon
          </li>
          <li>Need a higher API calls limit at 1,000 calls per minute</li>
          <li>Have a very active strategy with a high refresh rate</li>
          <li>
            Trading Professional: either a registered individual or conduct
            trading as primary means of generating income (full time or
            part-time)
          </li>
        </ul>
        <Text className="mt-8 font-semibold">
          Elite Smart Router is a non-retail route. Please read the disclosure
          below before you proceed.
        </Text>
        <div className="mt-8 rounded border border-gray-200 bg-gray-50 p-4">
          <Text className="pb-4 font-semibold">
            Order Flow Character Disclosure
          </Text>
          <Text className="text-sm">
            There are distinct benefits to having your order flow handled as
            retail orders. Among those benefits are, retail order flow is given
            priority for execution, retail-sized orders are entitled to the
            displayed quote, many retail orders are given price improvement, and
            there are rules that protect retail order flow from predatory
            trading practices.
            <br />
            <br />
            It is important to know that if your orders will not be
            characterized as retail orders, orders submitted will be classified
            as “not held” orders and are not covered orders under Reg NMS. If
            you continue to enter orders after this change, this is considered
            to be consent to the orders being handled as not held orders.
          </Text>
        </div>
      </div>
    </Modal>
  );
};
